export default {
  getCurrency : (state) => { return state.currency; },
}
